import state from "./logoState";
import mutations from "./logoMutation";
import actions from "./logoActions";
import getters from "./logoGetters.js";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
